import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  gap: 0.4rem;
  background: ${({ theme }) => theme.white};
  border-radius: 10px;
  padding: 0.8rem 0.4rem;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const TextMessageError = styled.p`
  position: absolute;
  bottom: -1.2rem;
  left: 0;
  margin: 0;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.red};
`;
export const TextFromTo = styled.span`
  font-size: 1rem;
  color: ${({ theme }) => theme.grayDark};
`;

export const InpuTWithSuffix = styled.div`
  position: relative;
  width: 100%;

  .MuiFormControl-root {
    border-radius: 0;
    width: calc(100% - 1rem);
  }
  .MuiInputBase-input {
    border-bottom: 1px solid ${({ theme }) => theme.grayDark};
    text-align: center;
    padding: 0;
  }
  ::after {
    content: '%';
    position: absolute;
    right: 0;
    top: 50%;
    font-size: 1rem;
    transform: translateY(-50%);
    color: ${({ theme }) => theme.grayDark};
  }
`;

